import { NgModule } from '@angular/core';
import { CommonModule }  from '@angular/common';
import { HttpModule } from '@angular/http';
import { MdlModule } from '@angular-mdl/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatRippleModule } from '@angular/material';
import { FormsModule } from '@angular/forms';

// Import the Froala Editor plugin.
import "froala-editor/js/froala_editor.pkgd.min.js";
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';

import { TranslateModule } from '../../../translate/translate.module';
import { PipeModule } from '../../../pipes/pipes.module';

import { FollowUpEmail } from './follow-up-email/follow-up-email.component';
import { Dialog2 } from './dialog2/dialog2.component';
import { PhoneFollowUpPopup } from './phone-follow-up-popup/phone-follow-up-popup.component';
import { FollowUpSms } from './follow-up-sms/follow-up-sms.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    HttpModule,
    MatRippleModule,
    FormsModule,
    TranslateModule,
    MdlModule,
    PipeModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot()
  ],
  declarations: [
    FollowUpEmail,
    FollowUpSms,
    Dialog2,
    PhoneFollowUpPopup
  ],
  exports: [FollowUpEmail, Dialog2, PhoneFollowUpPopup, FollowUpSms],
  entryComponents: [FollowUpEmail, Dialog2, PhoneFollowUpPopup, FollowUpSms]
})
export class ModalModule { }